import { withBemMod } from '@bem-react/core';

import { cnRadioButton } from '../RadioButton.cn';

import './RadioButton_view_contrast.css';

export type WithViewContrastProps = {
    view?: 'contrast';
};

export const withViewContrast = withBemMod<WithViewContrastProps>(cnRadioButton(), {});
